import CompositionContentType from 'models/composition/composition_content_type';

/**
 * What an activity is being done to. Only meaningful for activities that act on
 * something — composing does, viewing doesn't.
 */
const CustomerViewerActivityTarget = {
  REPLY: 'REPLY',
  NOTE: 'NOTE',
  TASK: 'TASK',
};

/**
 * Everything that isn't a note or a task collapses to REPLY. The distinction that
 * matters to a colleague is "are they writing to the customer, or working the
 * record" — naming the channel a reply goes out on would say more about what someone
 * is doing than the feature needs.
 */
export function targetForCompositionType(contentType) {
  switch (contentType) {
    case CompositionContentType.CONVERSATION_NOTE:
      return CustomerViewerActivityTarget.NOTE;
    case CompositionContentType.TASK:
    case CompositionContentType.TASK_EDIT:
      return CustomerViewerActivityTarget.TASK;
    default:
      return CustomerViewerActivityTarget.REPLY;
  }
}

export default CustomerViewerActivityTarget;
